/* ============================================================
   Modulo: Top Emblem — spinning back-to-top badge.

   - Relocates each badge to <body> on init so position: fixed is
     anchored to the viewport even inside a transformed theme wrapper.
   - One shared rAF-throttled scroll handler drives every badge:
     reveals past data-threshold (% scrolled) and, when
     data-progress is set, traces the scroll-depth ring.
   - In the theme editor (Shopify.designMode) the badge is always
     shown; section load/unload events keep the relocated node in sync.
   - Eyes follow the cursor on fine-pointer, motion-OK devices.
   - prefers-reduced-motion: instant scroll, frozen spin + pupils.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  var badges = [];          // active, relocated badge roots
  var scrollBound = false;
  var pointerBound = false;
  var ticking = false;

  /* ── shared scroll loop ── */
  function update() {
    ticking = false;
    var doc = document.documentElement;
    var top = window.pageYOffset || doc.scrollTop || 0;
    var max = (doc.scrollHeight - doc.clientHeight) || 1;
    var pct = top / max;
    for (var i = 0; i < badges.length; i++) {
      var el = badges[i];
      var show = el._btePreview || (pct * 100 >= el._bteThreshold && top > 40);
      el.classList.toggle('is-visible', show);
      if (el._bteMeter) el._bteMeter.style.strokeDashoffset = String(1 - pct);
    }
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }
  function bindScroll() {
    if (scrollBound) return;
    scrollBound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* ── eyes follow cursor (fine pointer + motion OK) ── */
  function onPointerMove(e) {
    for (var i = 0; i < badges.length; i++) {
      var pupils = badges[i]._btePupils;
      if (!pupils || !pupils.length) continue;
      for (var j = 0; j < pupils.length; j++) {
        var p = pupils[j];
        var r = p.parentNode.getBoundingClientRect();
        if (!r.width) continue;
        var a = Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2));
        var rad = Math.min(r.width, r.height) * 0.16;
        p.style.transform = 'translate(' + (Math.cos(a) * rad) + 'px,' + (Math.sin(a) * rad) + 'px)';
      }
    }
  }
  function bindPointer() {
    if (pointerBound || REDUCE) return;
    if (!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    pointerBound = true;
    window.addEventListener('pointermove', onPointerMove, { passive: true });
  }

  /* ── init one badge ── */
  function init(el) {
    if (el.dataset.moduloBteReady === '1') return;
    el.dataset.moduloBteReady = '1';

    var threshold = parseFloat(el.getAttribute('data-threshold'));
    el._bteThreshold = isNaN(threshold) ? 25 : threshold;
    el._btePreview = DESIGN;
    el._bteMeter = el.getAttribute('data-progress') === '1' ? el.querySelector('.modulo-bte__prog-meter') : null;
    el._btePupils = el.querySelectorAll('.modulo-bte__pupil');

    var btn = el.querySelector('.modulo-bte__badge');
    if (btn) {
      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: REDUCE ? 'auto' : 'smooth' });
      });
    }

    badges.push(el);
    bindScroll();
    bindPointer();
    update();
  }

  /* ── relocate to <body>, de-duping any prior copy of the same section ── */
  function relocateAndInit(el) {
    var sid = el.getAttribute('data-section-id') || '';
    if (sid) {
      var prev = document.body.querySelectorAll('[data-modulo-bte][data-section-id="' + sid + '"][data-modulo-bte-relocated="1"]');
      for (var i = 0; i < prev.length; i++) {
        if (prev[i] !== el) removeBadge(prev[i]);
      }
    }
    if (el.getAttribute('data-modulo-bte-relocated') !== '1') {
      document.body.appendChild(el);
      el.setAttribute('data-modulo-bte-relocated', '1');
    }
    init(el);
  }

  function removeBadge(el) {
    var k = badges.indexOf(el);
    if (k > -1) badges.splice(k, 1);
    if (el.parentNode) el.parentNode.removeChild(el);
    // Last badge gone (e.g. section deleted in the editor) → release the shared window
    // listeners so nothing lingers; bindScroll/bindPointer re-attach on the next init.
    if (badges.length === 0) {
      if (scrollBound) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        scrollBound = false;
      }
      if (pointerBound) {
        window.removeEventListener('pointermove', onPointerMove);
        pointerBound = false;
      }
    }
  }

  /* ── boot ── */
  function boot() {
    var els = document.querySelectorAll('[data-modulo-bte]');
    for (var i = 0; i < els.length; i++) relocateAndInit(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ── theme editor: keep the relocated node in sync on re-render ── */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-modulo-bte]') : null;
    if (el) relocateAndInit(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var sid = e.detail && e.detail.sectionId;
    if (!sid) return;
    var n = document.body.querySelectorAll('[data-modulo-bte][data-section-id="' + sid + '"]');
    for (var i = 0; i < n.length; i++) removeBadge(n[i]);
  });
})();
